import React from 'react';
import { Link } from 'react-router-dom';
import { ArchImage, Label, Mullions, Reveal } from './System';
import Icon from './Icon';

// variant="product": text on limestone, sized to its content, with a plate bleeding off the right edge and
// crossing 64px into the next section. That section should use a different ground, so the seam is visible.
// variant="memo": a compact memorandum header for the reviewer pages, with a small plate on the grid.
function PageHero({ variant = 'product', image, alt = '', eyebrow, title, subtitle, badge, primary, children }) {
  if (variant === 'memo') {
    return (
      <section className="relative overflow-hidden border-b border-wall/20 bg-limestone">
        <Mullions />
        <div className="shell">
          <div className="grid-12 relative gap-y-8 pb-12 pt-12 lg:pb-16 lg:pt-20">
            <Reveal className="col-span-4 lg:col-span-8">
              <Label className="mb-5">{eyebrow}</Label>
              <h1 className="type-h1-compact">{title}</h1>
              {subtitle && <p className="type-lead mt-6 text-glass">{subtitle}</p>}
              {badge && (
                <dl className="m-0 mt-9 flex flex-wrap gap-x-10 gap-y-2 border-t border-wall/25 pt-3 text-[14px]">
                  <div className="flex gap-3">
                    <dt className="font-semibold">Status</dt>
                    <dd className="m-0 text-glass figure">{badge}</dd>
                  </div>
                </dl>
              )}
            </Reveal>
            {image && (
              <ArchImage
                name={image}
                alt={alt}
                priority
                sizes="(min-width: 1024px) 26vw, 100vw"
                className="col-span-4 hidden h-[260px] lg:col-span-3 lg:col-start-10 lg:block"
              />
            )}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="relative z-10 bg-limestone">
      <Mullions />
      <div className="shell">
        <div className="grid-12 relative">
          <Reveal className="col-span-4 pb-10 pt-12 lg:col-span-6 lg:py-20 xl:py-24">
            <Label className="mb-5">{eyebrow}</Label>
            <h1 className="type-h1">{title}</h1>
            {subtitle && <p className="type-lead mt-7 text-glass">{subtitle}</p>}
            {primary && (
              <div className="mt-9">
                <Link to={primary.to} className="btn-primary">
                  {primary.label}
                  <Icon name="arrow" size={16} />
                </Link>
              </div>
            )}
            {badge && <p className="mt-9 border-t border-wall/25 pt-3 text-[14px] font-semibold">{badge}</p>}
            {children}
          </Reveal>
        </div>
      </div>
      <ArchImage
        name={image}
        alt={alt}
        priority
        sizes="(min-width: 1024px) 44vw, 100vw"
        className="aspect-[16/10] w-full lg:absolute lg:bottom-[-64px] lg:right-0 lg:top-0 lg:aspect-auto lg:w-[44vw] lg:shadow-panel"
      />
    </section>
  );
}

export default PageHero;
